/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CmsButtonApiProps, CmsButtonApiPropsSchema } from './cms-button'
import {
  type ProductCategories,
  ProductCategoriesSchema,
} from './product-category'

/* TypeScript */
export type AnimatedProductCheckpointsApiProps = {
  technicalName?: Maybe<string>
  title?: Maybe<string>
  subtitle?: Maybe<string>
  categories: ProductCategories
  button?: Maybe<CmsButtonApiProps>
}

/* Schemas */
export const AnimatedProductCheckpointsApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
  categories: ProductCategoriesSchema,
  button: z.nullish(CmsButtonApiPropsSchema),
})

/* Schemas validation */
type TestAnimatedProductCheckpointsProps = ExpectTrue<
  Equal<
    AnimatedProductCheckpointsApiProps,
    z.infer<typeof AnimatedProductCheckpointsApiPropsSchema>
  >
>
